import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useEffect } from 'react'

type ICaptchaManager = {
  getCaptcha: () => Promise<string>
}

export class CaptchaManager {
  captchaManager: ICaptchaManager = {
    getCaptcha: async () => {
      return ''
    },
  }
  static instance: CaptchaManager

  static getInstance() {
    if (!CaptchaManager.instance) {
      CaptchaManager.instance = new CaptchaManager()
    }
    return CaptchaManager.instance
  }

  static register(functions: ICaptchaManager) {
    CaptchaManager.getInstance().captchaManager = functions
  }

  static async getFreshCaptcha() {
    return CaptchaManager.getInstance()?.captchaManager?.getCaptcha()
  }
}

export const useNewCaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  useEffect(() => {
    if (executeRecaptcha) {
      CaptchaManager.register({
        getCaptcha: () => executeRecaptcha('login'),
      })
    }
  }, [executeRecaptcha])
}
